<div class="flex justify-end">
  <app-confirm-dialog
    [show]="showConfirmDialog"
    [message]="message"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
  ></app-confirm-dialog>
  <app-button (click)="openModal()">Adicionar</app-button>
  <app-modal [show]="showModal" (close)="closeModal()">
    <form [formGroup]="clientRegister" class="w-[500px]">
      <app-input formControlName="label" placeholder="Client Label"></app-input>
    </form>

    <div class="flex justify-end mt-2">
      <app-button (click)="salvar()">Salvar</app-button>
    </div>
  </app-modal>
</div>
<app-loading [show]="loading"></app-loading>
<app-table [columns]="columns" [data]="data"></app-table>
